import React from 'react';
import {
  Box,
  Typography,
  Chip,
} from '@mui/material';
import { AdminPanelSettings } from '@mui/icons-material';
import type { DashboardStats } from '../../services/superAdminService';

interface DashboardHeaderProps {
  stats: DashboardStats;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({ stats }) => {
  return (
    <Box sx={{ 
      mb: 4, 
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      borderRadius: 2,
      p: 3,
      color: 'white'
    }}>
      <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
        <AdminPanelSettings sx={{ mr: 2, verticalAlign: 'middle', fontSize: 'inherit' }} />
        Super Admin Dashboard
      </Typography>
      <Typography variant="h6" sx={{ opacity: 0.9, fontWeight: 300 }}>
        Complete system control and monitoring • Real-time insights and management
      </Typography>
      <Box sx={{ mt: 2, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        <Chip 
          label={`${stats.totalUsers?.toLocaleString() || 0} Users`} 
          sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: 'white', fontWeight: 'bold' }}
        />
        <Chip 
          label={`${stats.totalJobs?.toLocaleString() || 0} Jobs`} 
          sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: 'white', fontWeight: 'bold' }}
        />
        <Chip 
          label={`${stats.totalApplications?.toLocaleString() || 0} Applications`} 
          sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: 'white', fontWeight: 'bold' }}
        />
      </Box>
    </Box>
  );
};

export default DashboardHeader;
